import { Component, input, InputSignal } from '@angular/core';
import { AppendTestIdPipe } from '../../../pipes/append-test-id/append-test-id.pipe';

@Component({
  selector: 'aw-payment-method-display',
  imports: [AppendTestIdPipe],
  templateUrl: './payment-method-display.component.html',
})
export class PaymentMethodDisplayComponent {
  public id: InputSignal<string> = input.required();
  public paymentMethod: InputSignal<any> = input.required();
}
